// @flow

// this used to be located in /site/components/packages/social/sections/locationSection
// but was moved to prevent dependency cycle issues.
export { default as LocationSectionPhotoWrap } from './LocationSectionPhotoWrap';
export { default as LocationSection } from './LocationSection';
